import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    this.handleInputSelectAll();
    this.handleInputAction();
    this.toggleInputSelectAll();
    return this;
  }

  handleInputSelectAll() {
    document.querySelectorAll('.permission-select-all').forEach((el) => {
      el.addEventListener('click', (ev) => {
        const input = ev.currentTarget;
        input.closest('ul').querySelectorAll('.permission-action').forEach((cb) => {
          cb.checked = input.checked;
        });
        this.toggleInputSelectAll();
      });
    });
  }

  handleInputAction() {
    document.querySelectorAll('.permission-action').forEach((el) => {
      el.addEventListener('click', (ev) => {
        this.updatePermissionSelectAll(ev.currentTarget);
      });
    });
  }

  toggleInputSelectAll() {
    document.querySelectorAll('.permission-select-all').forEach((el) => {
      this.updatePermissionSelectAll(el);
    });
  }

  updatePermissionSelectAll(inputAction) {
    const ul = inputAction.closest('ul');
    const total   = ul.querySelectorAll('input.permission-action').length;
    const checked = ul.querySelectorAll('input.permission-action:checked').length;
    const selectAll = ul.querySelector('.permission-select-all');

    selectAll.checked = total > 0 && checked === total;
    selectAll.indeterminate = checked > 0 && checked < total;
  }
}
